export default {
  en: {
    'components.aggregates.title': 'Transaction data summary',
    'components.aggregates.actions.view-log': 'View log',

    'components.aggregates-ecsl.title': 'ECSL Summary',
    'components.aggregates-ecpl.title': 'ECPL Summary',

    'components.aggregates-ecsl.load-more': 'Load more',
  },
};
